
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.937 3.953c2.22.655 3.716 3.054 4.71 7.55.503 2.272.688 4.025.568 5.36-.159 1.741-.852 2.833-2.063 3.246-.768.264-1.56.162-2.35-.299-.596-.346-1.193-.896-1.824-1.683-1.005-1.251-2.168-1.632-4.978-1.632-3.146 0-4.163.55-5.031 1.632-.77.957-1.894 2.125-3.297 2.125a2.656 2.656 0 01-.874-.15c-2.048-.71-2.582-3.764-1.497-8.603C2.31 7.003 3.805 4.605 6.013 3.953A5.426 5.426 0 017.5 3.75c.64 0 1.2.157 1.793.323.714.2 1.525.427 2.707.427s1.992-.227 2.706-.427c.592-.166 1.151-.323 1.794-.323.486-.002.97.066 1.437.203zM8 8a1 1 0 00-2 0v1H5a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2H8V8zm7 3a1 1 0 100-2 1 1 0 000 2zm4 0a1 1 0 100-2 1 1 0 000 2zm-2-2a1 1 0 100-2 1 1 0 000 2zm0 4a1 1 0 100-2 1 1 0 000 2z","fill":"#fff"}})])
          )
        }
      }
    